const BASE = '/api';

export async function getPresses(filters?: any) {
  const params = new URLSearchParams();
  if (filters) {
    Object.entries(filters).forEach(([k, v]) => {
      if (v != null) params.set(k, String(v));
    });
  }
  const r = await fetch(`${BASE}/presses?${params}`);
  if (!r.ok) throw new Error('Failed to load map');
  return r.json();
}

export async function pressWisdomCard(payload: {
  source_type: string;
  claim_summary: string;
  tension_text?: string;
  granularity: string;
  before_emotion: string;
  before_intensity: number;
  after_emotion: string;
  after_intensity: number;
  action_readiness: string[];
  pilgrim_token?: string;
}) {
  const r = await fetch(`${BASE}/press`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw new Error(err.error || 'Press failed');
  }
  return r.json();
}

export async function tendCard(pressId: string, payload: {
  after_emotion: string;
  after_intensity: number;
  evolution_note?: string;
  pilgrim_token: string;
}) {
  const r = await fetch(`${BASE}/presses/${pressId}/tend`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error((await r.json()).error || 'Update failed');
  return r.json();
}

export async function getMyBearings(pilgrimToken: string) {
  const r = await fetch(`${BASE}/my?token=${encodeURIComponent(pilgrimToken)}`);
  if (!r.ok) throw new Error('Could not load your bearings');
  return r.json();
}

export async function getResonances(pressId: string) {
  const r = await fetch(`${BASE}/presses/${pressId}/resonances`);
  if (!r.ok) return { resonances: [] };
  return r.json();
}

export async function getInsights() {
  const r = await fetch(`${BASE}/insights`);
  if (!r.ok) throw new Error('Insights unavailable right now');
  return r.json();
}

export async function searchPresses(query: string) {
  const r = await fetch(`${BASE}/search?q=${encodeURIComponent(query)}`);
  if (!r.ok) return { results: [] };
  return r.json();
}

export async function postEvent(event_type: string, payload?: any) {
  try {
    await fetch(`${BASE}/events`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ event_type, payload }),
    });
  } catch {}
}
